interface IConfirmCandidateOutcomeJob {
  id?: string;
  multipleCounters?: Array<{
    candidate?: {
      id?: string;
    };
  }>;
}

interface IConfirmCandidateOutcomeResponse {
  isOnsiteInterview?: boolean;
  postingId?: string;
  local_date?: string;
}

export type TConfirmCandidateOutcome =
  | { type: 'payment_missing' }
  | { type: 'onsite_confirmed'; postingId?: string; localDate?: string }
  | { type: 'show_another_job_popup'; hasPendingJobs: boolean }
  | { type: 'show_eligible_jobs_popup' }
  | { type: 'confirmed_no_followup'; route: string };

interface IGetConfirmCandidateOutcomeParams {
  errorStatus?: number;
  noCardErrorStatus?: number;
  response?: IConfirmCandidateOutcomeResponse;
  jobId?: string;
  candidateId?: string;
  pendingJobs?: IConfirmCandidateOutcomeJob[];
  eligibleJobsCount?: number;
  dashboardPendingCount?: number;
}

export function getConfirmCandidateOutcome({
  candidateId,
  dashboardPendingCount,
  eligibleJobsCount = 0,
  errorStatus,
  jobId,
  noCardErrorStatus,
  pendingJobs = [],
  response,
}: IGetConfirmCandidateOutcomeParams): TConfirmCandidateOutcome {
  if (errorStatus && noCardErrorStatus && errorStatus === noCardErrorStatus) {
    return { type: 'payment_missing' };
  }

  if (response?.isOnsiteInterview) {
    return {
      type: 'onsite_confirmed',
      postingId: response.postingId,
      localDate: response.local_date,
    };
  }

  const hasAnotherPendingCounterJob = pendingJobs.some(
    (job) =>
      job.id !== jobId &&
      job.multipleCounters?.some((counter) => counter.candidate?.id === candidateId),
  );

  if (hasAnotherPendingCounterJob) {
    return { type: 'show_another_job_popup', hasPendingJobs: pendingJobs.length > 0 };
  }

  if (eligibleJobsCount > 0) {
    return { type: 'show_eligible_jobs_popup' };
  }

  return {
    type: 'confirmed_no_followup',
    route: `/dashboard/jobs/${dashboardPendingCount && dashboardPendingCount > 1 ? 'pending' : 'scheduled'}`,
  };
}
